import { Box, BoxProps } from "@mui/material";
import clsx from "clsx";
import { memo } from "react";
import style from "./index.module.scss";

export const PrivatePageContent = memo<BoxProps>(({ children, ...rest }) => {
  return (
    <Box {...rest} className={clsx(style.root, rest.className)}>
      {children}
    </Box>
  );
});
